export default __webpack_public_path__ + "static/media/Rectangle 373.dcb76300.png";